<div class="slider-info-above">
  @if (label) {
    <h3 class="label">
      {{ label | translate }}
    </h3>
  }

  <h3 class="current-value">{{ transformedValue }}</h3>
</div>

<div class="slider-bar">
  <mat-slider
    [min]="min"
    [max]="max"
    [step]="step"
    [disabled]="disabled || readonly"
    (blur)="onTouched()"
  >
    <input matSliderThumb [value]="value" (valueChange)="changeValue($event)" />
  </mat-slider>
</div>

@if (areMinMaxIndicatorsVisible) {
  <span class="min">{{ transformedMin }}</span>
  <span class="max">{{ transformedMax }}</span>
}
